

import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Card, Grid, Snackbar, Alert } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import DataLoadingSpinner from "components/Spinners/DataLoadingSpinner";
import { useAuth } from 'auth/Auth';
import { formatDate } from 'utils/DateTimeConversion';

const GuideTripNoteDetail = () => {
    const { id } = useParams();
    const { axiosInstance } = useAuth();
    const [note, setNote] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

    useEffect(() => {
        if (id) {
            fetchNoteDetail();
        }
    }, [id]);

    const fetchNoteDetail = async () => {
        setIsLoading(true);
        try {
            const response = await axiosInstance.get(`/guide-trip-notes/${id}`);
            setNote(response.data);
        } catch (error) {
            console.error('Error fetching guide trip note details:', error);
            setSnackbar({ open: true, message: 'Error loading guide trip note details', severity: 'error' });
        } finally {
            setIsLoading(false);
        }
    };

    if (isLoading) {
        return (
            <DashboardLayout>
                <DashboardNavbar />
                <DataLoadingSpinner title="Loading Guide Trip Note Details" message="Please wait..." />
                
            </DashboardLayout>
        );
    }

    if (!note) {
        return (
            <DashboardLayout>
                <DashboardNavbar />
                <MDBox p={6}><MDTypography color="error">Guide Trip Note not found</MDTypography></MDBox>
                
            </DashboardLayout>
        );
    }

    const mainInfo = {
        "Name": note.name,
        "Date": note.date ? formatDate(note.date) : '-',
        "Guide": note.guide?.name || note.guide_id || '-',
        "Trip": note.trip?.name || note.trip_id || '-',
        "Trip Option": note.trip_option?.name || note.trip_option_id || '-',
        "Did Day Run According to Plan?": note.did_day_run_according_to_plan || '-',
        "Accidents/Injuries": note.accidents_injuries || '-',
        "Behaviour Concerns": note.behaviour_concerns || '-',
        "Weather Issues": note.weather_issues || '-',
        "Any Other Notes": note.any_other_notes || '-',
    };

    const renderDetailCard = (title, data) => (
        <MDBox m={3} p={3} borderRadius="lg" sx={{ backgroundColor: 'white', boxShadow: 3 }}>
            <MDTypography variant="h6" fontWeight="medium" color="dark" mb={2}>
                {title}
            </MDTypography>
            <Grid container spacing={3}>
                {Object.entries(data).map(([key, value]) => (
                    <Grid item xs={12} sm={6} key={key}>
                        <MDBox display="flex" alignItems="center">
                            <MDTypography variant="button" fontWeight="bold" color="text">
                                {key}:
                            </MDTypography>
                            <MDTypography fontSize="0.9rem" color="text" ml={1}>
                                {value}
                            </MDTypography>
                        </MDBox>
                    </Grid>
                ))}
            </Grid>
        </MDBox>
    );

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox mx={2} mt={-3} py={3} px={2} variant="gradient" bgColor="info" borderRadius="lg" coloredShadow="info">
                                <MDTypography variant="h6" color="white">
                                    Guide Trip Note Details: {note.name}
                                </MDTypography>
                            </MDBox>
                            <MDBox>
                                {renderDetailCard('Note Information', mainInfo)}
                            </MDBox>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
            
            <Snackbar
                open={snackbar.open}
                autoHideDuration={6000}
                onClose={() => setSnackbar({ ...snackbar, open: false })}
            >
                <Alert severity={snackbar.severity} onClose={() => setSnackbar({ ...snackbar, open: false })}>
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </DashboardLayout>
    );
};

export default GuideTripNoteDetail;

